export const CustomMasterItems = {
    name: ""
}
export const CustomMasterData = {
    name: "",
    categoryType: "",
    customMasterItems: [CustomMasterItems]
}

